/**
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2017, Codrops
 * http://www.codrops.com
 */
(function ( $ ) {
	
	'use strict';
	
	const pluginName = 'liquidDynamicShape';
	let defaults = {
		
	};
	
	class Plugin {
		
		constructor(element, options) {
			
			this.options = $.extend( {}, defaults, options) ;
			
			this._defaults = defaults;
			this._name = pluginName;
			
			this.DOM = {};
			this.DOM.element = element;
			this.DOM.svgEl = this.DOM.element.querySelector('svg');
			this.DOM.pathEl = this.DOM.element.querySelector('path');
			this.paths = this.DOM.pathEl.getAttribute('pathdata:id').trim().split(';');
			this.paths.splice(this.paths.length, 0, this.DOM.pathEl.getAttribute('d'));

			this.timeline = null;
			
			this.createTimeline();
			this.init();

		}

		createTimeline() {

			const keyframes = this.paths.map( path => {
				return { d: path.trim() }
			});
	
			this.timeline = gsap.timeline({
				repeat: -1,
				yoyo: true
			}).pause();
			
			for (let i = 0; i < keyframes.length; i++) {
				
				this.timeline.to(this.DOM.pathEl, {
					attr: {
						d: keyframes[i].d
					},
					duration: 2
				});

			}

		}

		init() {
			
			this.animate();
			
		}
	
		animate() {
			this.timeline.play();
		}

		pause() {
			this.timeline.pause();
		}

	}
	
	$.fn[ pluginName ] = function( options ) {
		
		return this.each( function() {
			
			const pluginOptions = {...$(this).data('mi-options'), ...options};
			
			if ( !$.data( this, "plugin_" + pluginName ) ) {
				$.data( this, "plugin_" + pluginName, new Plugin( this, pluginOptions ) );
			}
			
		} );
		
	};
	
}(jQuery));

jQuery(document).ready( function($) {

	if ( liquidIsMobile() ) return;

	$('[data-dynamic-shape]').filter( (i, element) => {

		const $element = $(element);
		const $fullpageSection = $element.closest('.vc_row.pp-section');

		return (
			! $fullpageSection.length
		);

	} ).liquidDynamicShape();
	
});